export const baseData = {
  // 增值服务 服务类别
  serviceTypeArr:[
    {
      label: "基础服务",
      value: 1,
    },
    {
      label: "财税服务",
      value: 2,
    },
    {
      label: "外呼服务",
      value: 3,
    },
    {
      label: "企微服务",
      value: 4,
    },
  ],
  // 模板类型  新作的平台里面
  newTemplateArr:[
    {
      value: 1,
      label: "费用单据"
    }
  ],
  // 报表类型

  // 快递类型
  cartonTypeArr: [
    {
      label: "京东快递",
      value: 1
    },
    {
      label: "德邦快递",
      value: 2
    }
  ],
  // 快递产品类别
  logisticsHeavyTypeArr: [
    {
      label: "标件",
      value: 1
    },
    {
      label: "大件",
      value: 2
    },
    // {
    //   label: "微小件",
    //   value: 3
    // }
  ],
  reportForms:[{
    value: 1,
    label: "资产负债表"
  },{
    value: 2,
    label: "利润表"
  },{
    value: 3,
    label: "现金流量表"
  },{
    value:4,
    label: "业务活动表"
  },{
    value: 5,
    label: "收益及收益分配表"
  },{
    value: 6,
    label: "盈余及盈余分配表"
  },{
    value: 7,
    label: "成员权益变动表"
  },{
    value: 8,
    label: "收入费用表"
  }],


  // <el-option :value="1" label="资产负债表"></el-option>
  // <el-option :value="2" label="利润表"></el-option>
  // <el-option :value="3" label="现金流量表"></el-option>
  // <el-option :value="4" label="业务活动表"></el-option>
  // <el-option :value="5" label="收益及收益分配表"></el-option>
  // <el-option :value="6" label="盈余及盈余分配表"></el-option>
  // <el-option :value="7" label="成员权益变动表"></el-option>

  // 会计科目那边
  hierarchyOnly: [{
      value: "资产",
      label: "资产"
    },
    {
      value: "负债",
      label: "负债"
    },
    {
      value: "权益",
      label: "权益"
    },
    {
      value: "成本",
      label: "成本"
    },
    {
      value: "损益",
      label: "损益"
    },
    {
      value: "共同类",
      label: "共同类"
    }, {
      value: "净资产",
      label: "净资产"
    },
    {
      value: "收入",
      label: "收入"
    },
    {
      value: "费用",
      label: "费用"
    }, {
      value: "预算收入",
      label: "预算收入"
    },
    {
      value: "预算支出",
      label: "预算支出"
    },
    {
      value: "预算结余",
      label: "预算结余"
    }
  ],
  //科目以起初
  hierarchy: {
    '新企业会计准则': [{
        value: "资产",
        label: "资产"
      },
      {
        value: "负债",
        label: "负债"
      },
      {
        value: "权益",
        label: "权益"
      },
      {
        value: "成本",
        label: "成本"
      },
      {
        value: "损益",
        label: "损益"
      },
      {
        value: "共同类",
        label: "共同类"
      },
    ],
    '小企业会计准则': [{
        value: "资产",
        label: "资产"
      },
      {
        value: "负债",
        label: "负债"
      },
      {
        value: "权益",
        label: "权益"
      },
      {
        value: "成本",
        label: "成本"
      },
      {
        value: "损益",
        label: "损益"
      },
    ],
    '农民专业合作社财务会计制度': [{
        value: "资产",
        label: "资产"
      },
      {
        value: "负债",
        label: "负债"
      },
      {
        value: "权益",
        label: "权益"
      },
      {
        value: "成本",
        label: "成本"
      },
      {
        value: "损益",
        label: "损益"
      },
    ],
    '政府会计制度': [{
        value: "资产",
        label: "资产"
      },
      {
        value: "负债",
        label: "负债"
      }, {
        value: "净资产",
        label: "净资产"
      },
      {
        value: "收入",
        label: "收入"
      },
      {
        value: "费用",
        label: "费用"
      },
      {
        value: "预算收入",
        label: "预算收入"
      },
      {
        value: "预算支出",
        label: "预算支出"
      },
      {
        value: "预算结余",
        label: "预算结余"
      }
    ],
    '民间非营利组织': [{
        value: "资产",
        label: "资产"
      },
      {
        value: "负债",
        label: "负债"
      }, {
        value: "净资产",
        label: "净资产"
      },
      {
        value: "收入",
        label: "收入"
      },
      {
        value: "费用",
        label: "费用"
      }
    ],
    '担保公司会计准则':[
      {
        value: "资产",
        label: "资产"
      },
      {
        value: "负债",
        label: "负债"
      },
      {
        value: "共同类",
        label: "共同类"
      },
      {
        value: "权益",
        label: "权益"
      },{
        value: "损益",
        label: "损益"
      }],
    '村集体经济组织会计制度': [{
        value: "资产",
        label: "资产"
      },
      {
        value: "负债",
        label: "负债"
      },
      {
        value: "权益",
        label: "权益"
      },
      {
        value: "成本",
        label: "成本"
      }, {
        value: "损益",
        label: "损益"
      }
    ],
    '房地产企业会计准则': [{
        value: "资产",
        label: "资产"
      },
      {
        value: "负债",
        label: "负债"
      },
      {
        value: "权益",
        label: "权益"
      },
      {
        value: "成本",
        label: "成本"
      }, {
        value: "损益",
        label: "损益"
      }
    ],
    '医院会计准则':[{
      value: "资产",
      label: "资产"
    },{
        value: "负债",
        label: "负债"
      },{
        value: "损益",
        label: "损益"
      }, {
        value: "净资产",
        label: "净资产"
      }, {
        value: "收入",
        label: "收入"
      }]
  },

  // 发票
  autoGenOption: [{
      text: '全部',
      val: null
    },
    {
      text: '增值税专用发票',
      val: 1
    }
  ],
  // 公司类型
  companyType: [{
      text: '股份有限公司',
      val: 1
    },
    {
      text: '集体所有制企业',
      val: 2
    },
    {
      text: '全民所有制企业',
      val: 3
    },
    {
      text: '有限合伙企业',
      val: 4
    },
    {
      text: '普通合伙企业',
      val: 5
    },
    {
      text: '个体工商户',
      val: 6
    },
    {
      text: '个人独资企业',
      val: 7
    },
    {
      text: '有限责任公司',
      val: 8
    },
    {
      text: '家庭农场',
      val: 9
    },
    {
      text: '专业合作社',
      val: 10
    },
    {
      text: '民办非企业',
      val: 11
    },
    {
      text: '法律服务所',
      val: 12
    },
    {
      text: '社会团体',
      val: 13
    },
    {
      text: '民办学校',
      val: 14
    },
    {
      text: '养老机构',
      val: 15
    }
  ],
  // 我的事项
  myBusinessArr: [{
      value: 1,
      text: '待分配'
    }, {
      value: 2,
      text: '待处理'
    },
    {
      value: 3,
      text: '处理中'
    },
    {
      value: 4,
      text: '已完成'
    },
    {
      value: 5,
      text: '已取消'
    }
  ],
  notesTypeArr: [{
    value: null,
    text: '全部'
    },{
      value: 1,
      text: '到期提醒'
    },
    {
      value: 2,
      text: '购买通知'
    },
    {
      value: 3,
      text: '催款提醒'
    },
    {
      value: 4,
      text: '付款提醒'
    },
    {
      value: 9,
      text: '续费提醒'
    },
    {
      value: 13,
      text: '到款提醒'
    },
    {
      value: 10,
      text: '服务通知'
    },{
      value: 11,
      text: '系统公告'
    }, {
      value: 12,
      text: '版本迭代'
    },{
      value: 5,
      text: '流失提醒'
    },
    {
      value: 14,
      text: '客户流转'
    },
    {
      value: 6,
      text: '任务提醒'
    },
    {
      value: 7,
      text: '订单错误'
    },
    {
      value: 8,
      text: '进度提醒'
    },

  ],
  // 系统消息
  notesSystemArr: [{
      value: null,
      text: '全部'
    },{
      value: 11,
      text: '系统公告'
    }, {
      value: 12,
      text: '版本迭代'
    },
    {
      value: 15,
      text: '工单提醒'
    },
  ],
  // 订单消息
  notesOrderArr: [
    {
    value: null,
    text: '全部'
    },{
      value: 1,
      text: '到期提醒'
    },
    {
      value: 2,
      text: '购买通知'
    },
    {
      value: 3,
      text: '催款提醒'
    },
    {
      value: 4,
      text: '付款提醒'
    },
    {
      value: 9,
      text: '续费提醒'
    },
    {
      value: 13,
      text: '到款提醒'
    },
    {
      value: 10,
      text: '服务通知'
    },
  ],
  // 任务消息
  notesTextArr: [
    {
    value: null,
    text: '全部'
    },
    {
      value: 5,
      text: '流失提醒'
    },
    {
      value: 14,
      text: '客户流转'
    },
    {
      value: 6,
      text: '任务提醒'
    },
    {
      value: 7,
      text: '订单错误'
    },
    {
      value: 8,
      text: '进度提醒'
    },
  ],
  taxOptions: [{
    val: 0,
    text: '次',
  }, {
    val: 1,
    text: '月',
  }, {
    val: 2,
    text: '季',
  }, {
    val: 3,
    text: '年',
  }],
  customerStateOpts: [{
      text: "全选",
      value: ""
    }, {
      text: "潜在",
      value: 1
    }, {
      text: "有意向",
      value: 2
    }, {
      text: "已签单",
      value: 3
    }, {
      text: "流失",
      value: 4
    }, {
      text: "其他",
      value: 5
    },
    {
      text: "同行",
      value: 6
    },
    {
      text: "无意向",
      value: 7
    },
    {
      text: "二次开发",
      value: 8
    },
    {
      text: "流转",
      value: 9
    }
  ],
  // 待办状态
  waitStatus: [{
    text: "待分配",
    value: 1
  }, {
    text: "待处理",
    value: 2
  }, {
    text: "处理中",
    value: 3
  }, {
    text: "已完成",
    value: 4
  }, {
    text: "已取消",
    value: 5
  }],
  // 动作类型
  actionOptions: [{
      text: "已完成",
      value: 1
    },
    {
      text: "更新进展",
      value: 2
    },
    {
      text: "转他人处理",
      value: 3
    },
    {
      text: "分配",
      value: 4
    }, {
      text: "已取消",
      value: 5
    }, {
      text: "移交",
      value: 6
    }, {
      text: "领取",
      value: 7
    }
  ],
  // 票据类型
  BillOptions: [{
      text: "销项票据",
      value: '1'
    },
    {
      text: "进项票据",
      value: '2'
    },
    {
      text: "费用票据",
      value: '3'
    },
    {
      text: "银行票据",
      value: '4'
    },
    {
      text: "无票收入",
      value: '5'
    },
  ],
  //店铺购买状态
  shopBuyStatus: ['待支付', '已支付', '已取消', '已删除'],
  // 票据类型 已处理，未处理
  Bill7Options: [{
      text: "增值税专用发票",
      value: '1'
    },
    {
      text: "增值税普通发票",
      value: '2'
    },
    {
      text: "增值税电子普通发票",
      value: '3'
    },
    {
      text: "增值税普通卷票",
      value: '4'
    },
    {
      text: "飞机行程单",
      value: '10'
    },
    {
      text: "火车票（交通票）",
      value: '5'
    },
    {
      text: "通行费（通用机打）",
      value: '6'
    },
    {
      text: "出租车费（通用机打）",
      value: '7'
    },
    {
      text: "旅客运输普票",
      value: '8'
    },
    {
      text: "公路客运发票",
      value: '9'
    },
    {
      text: "通用定额发票",
      value: '11'
    },
    {
      text: "机动车销售统一发票",
      value: '12'
    },
    {
      text: "二手车销售统一发票",
      value: '13'
    },
    {
      text: "银行票据",
      value: '14'
    },
    {
      text: "增值税普通发票（电子）",
      value: '15'
    },
    {
      text: "增值税普通发票（卷票）",
      value: '16'
    },
    // {
    //   text: "存备用金",
    //   hidden:true,
    //   value: '21'
    // },
    // {
    //   text: "备用金转出",
    //   hidden:true,
    //   value: '22'
    // },
    // {
    //   text: "银行手续费",
    //   hidden:true,
    //   value: '23'
    // },
  ],
  //税盘 使用税率
  usedRate: {
    'xgm': [ // 小规模纳税人

      {
        tax: ['zy', 'pt', 'ptdz'],
        text: "5%",
        value: '5'
      },
      {
        tax: ['zy', 'pt', 'ptdz'],
        text: "3%",
        value: '3'
      },
      {
        tax: ['zy',  'ptdz'],
        text: "1%",
        value: '1'
      },
      // {
      //   tax: ['ptdz'],
      //   text: "0%",
      //   value: '0'
      // },
      // {
      //   tax: ['zy', 'pt'],
      //   text: "减按1.5%计算",
      //   value: 'ja1.5'
      // },
      {
        tax: ['pt', 'ptdz'],
        text: "免税",
        value: 'ms'
      },
      {
        tax: ['pt', 'ptdz'],
        text: "不征税",
        value: 'bzs'
      }
    ],
    // //起征点以下
    // 'qzd':[
    //
    //   {
    //     tax: ['zy', 'pt', 'ptdz'],
    //     text: "5%",
    //     value: '5'
    //   },
    //   {
    //     tax: ['zy', 'pt', 'ptdz'],
    //     text: "3%",
    //     value: '3'
    //   },
    //   {
    //     tax: ['zy',  'ptdz'],
    //     text: "1%",
    //     value: '1'
    //   },
    //   {
    //     tax: ['ptdz'],
    //     text: "0%",
    //     value: '0'
    //   },
    //   {
    //     tax: ['zy', 'pt'],
    //     text: "减按1.5%计算",
    //     value: 'ja1.5'
    //   },
    //   {
    //     tax: ['pt', 'ptdz'],
    //     text: "免税",
    //     value: 'ms'
    //   },
    //   {
    //     tax: ['pt', 'ptdz'],
    //     text: "不征税",
    //     value: 'bzs'
    //   }
    // ],
    'yb': [{
        tax: ['zy', 'pt', 'ptdz'], //一般纳税人
        text: "13%",
        value: '13'
      },
      {
        tax: ['zy', 'pt', 'ptdz'],
        text: "9%",
        value: '9'
      },
      {
        tax: ['zy', 'pt', 'ptdz'],
        text: "6%",
        value: '6'
      },
      {
        tax: ['zy', 'pt', 'ptdz'],
        text: "5%",
        value: '5'
      },
      {
        tax: ['zy', 'pt', 'ptdz'],
        text: "4%",
        value: '4'
      },
      {
        tax: ['zy', 'pt', 'ptdz'],
        text: "3%",
        value: '3'
      },
      // {
      //   tax: ['zy', 'pt'],
      //   text: "减按1.5%计算",
      //   value: 'ja1.5'
      // },
      // {
      //   tax: ['zy'],
      //   text: "中外合作油气田",
      //   value: 'yqt'
      // },
      // {
      //   tax: ['pt', 'ptdz'],
      //   text: "0%",
      //   value: '0'
      // },
      {
        tax: ['pt', 'ptdz'],
        text: "免税",
        value: 'ms'
      },
      {
        tax: ['pt', 'ptdz'],
        text: "不征税",
        value: 'bzs'
      },
    ]
  },
  specUsedRate: [
  //   {
  //   text: "正常税率",
  //   value: '0'
  // },
    {
    text: "免税",
    value: 1
  }, {
    text: "不征税",
    value: 2
  },
  //   {
  //   text: "普通零税率",
  //   value: '3'
  // }
  ],
  // 发票
  billTypeArray: [{
      tax: 'zy',
      text: "增值税专用发票",
      // value: 2
    value:1
    },
    {
      tax: 'pt',
      text: "增值税普通发票",
      // value: 1
      value: 2
    },
    {
      tax: 'ptdz',
      text: "增值税普通电子发票",
      // value: 0
      value: 3
    },
  ],
};
